/**
 * Counters - slot machine style number reveal.
 * Digits spin rapidly then snap to final value with a lock pulse + ripple.
 */

export function initCounters(root: HTMLElement): () => void {

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          const el = entry.target as HTMLElement;
          const target = Number(el.dataset.countTo ?? 0);
          const stagger = Number(el.dataset.countStagger ?? 0);
          setTimeout(() => animateSlotMachine(el, target), stagger);
          observer.unobserve(el);
        }
      }
    },
    { threshold: 0.5 },
  );

  root.querySelectorAll('[data-count-to]').forEach((el) => observer.observe(el));

  return () => observer.disconnect();
}

function animateSlotMachine(el: HTMLElement, target: number) {
  const spinDuration = 1200;
  const digits = String(target);
  el.textContent = '';
  el.classList.add('counter-spinning');

  const digitEls: HTMLSpanElement[] = [];
  for (let i = 0; i < digits.length; i++) {
    const digitWrap = document.createElement('span');
    digitWrap.className = 'counter-digit';
    digitWrap.textContent = '0';
    el.appendChild(digitWrap);
    digitEls.push(digitWrap);
  }

  const start = performance.now();
  const lockTimes = digitEls.map((_, i) => spinDuration - (digits.length - 1 - i) * 150);

  function frame(now: number) {
    const elapsed = now - start;
    let allLocked = true;

    for (let i = 0; i < digitEls.length; i++) {
      const digitEl = digitEls[i];
      const lockTime = lockTimes[i];
      if (!digitEl || lockTime === undefined) continue;
      if (elapsed >= lockTime) {
        if (!digitEl.classList.contains('counter-locked')) {
          digitEl.textContent = digits[i] ?? '';
          digitEl.classList.add('counter-locked');
        }
      } else {
        allLocked = false;
        digitEl.textContent = String(Math.floor(Math.random() * 10));
      }
    }

    if (!allLocked) {
      requestAnimationFrame(frame);
    } else {
      el.classList.remove('counter-spinning');
      el.classList.add('counter-complete');
    }
  }

  requestAnimationFrame(frame);
}
